import { render, staticRenderFns } from "./contentlocalization.vue?vue&type=template&id=bc217068"
import script from "./contentlocalization.vue?vue&type=script&lang=js"
export * from "./contentlocalization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports